import {AppMenuItem} from '../../shared/interfaces/menu-config-interface';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';
import {AmbienteEnum} from '../../shared/enums/ambiente-enum';
import {SociedadEnum} from '../../shared/enums/sociedad-enum';
import {MENU_PERMISSIONS} from '../constants/menu-permissions.constant';

export const ADMINISTRACION_MENU: AppMenuItem = {
  "children": [
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "label": "Cambiar Punto de Venta",
      "route": "SeleccionarPV",
      "proceso": MENU_PERMISSIONS.seleccionarPV,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "label": "Configuración de equipo",
      "route": "AdminRegistro",
      "proceso": MENU_PERMISSIONS.adminRegistro,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX,
        SociedadEnum.SCFRAN
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Catálogos Actualizables",
          "route": "mantenimiento/actualizables",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Catálogos de Consulta",
          "route": "mantenimiento/consulta",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Carga Inicial",
          "route": "mantenimiento/carga-inicial",
          "visible": false
        }
      ],
      "label": "Mantenimiento a Catálogos",
      "proceso": MENU_PERMISSIONS.mantenimientoCatalogos,
      "route": "mantenimiento/catalogos",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.CO
      ],
      "label": "Aumentar Folio Consecutivo",
      "route": "aumentar-folio-colombia",
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    }
  ],
  "label": "Administración",
  "visible": true
};
